export function formt(n) {
    if (n && n.toString) {
        return n.toString()[1] ? n : '0' + n
    }
    return ''
}
